import {
  FacebookIcon,
  InstagramIcon,
  LinkedinIcon,
  TwitterIcon,
} from '../../../components/icons/BrandIcons';
import { colors } from '../../../theme/colors';
import type { LeadPlatform } from '../utils/leadPlatforms';

const ICONS: Record<LeadPlatform, typeof LinkedinIcon> = {
  linkedin: LinkedinIcon,
  instagram: InstagramIcon,
  facebook: FacebookIcon,
  twitter: TwitterIcon,
};

/** The brand glyph for a network, at the size the info rows use. */
export function PlatformIcon({
  platform,
  size = 16,
}: Readonly<{ platform: LeadPlatform; size?: number }>) {
  const Icon = ICONS[platform];
  return <Icon size={size} color={colors.text.tertiary} />;
}
